// Логика карточки «Биометрия» («Настройки» → «Общие») вне JSX: черновик формы, проверка,
// тело запроса и описание результата «Проверить подключение».
//
// Токен сервер не отдаёт: в ответе только hasToken и последние символы. Поэтому поле токена
// в форме всегда начинается пустым, а пустое значение при сохранении значит «не менять».

export const draftFromSettings = (settings) => ({
  enabled: Boolean(settings?.enabled),
  baseUrl: settings?.baseUrl ?? '',
  token: '',
  model: settings?.model ?? ''
});

const trimmed = (value) => (typeof value === 'string' ? value.trim() : '');

export const isHttpUrl = (value) => /^https?:\/\/[^\s]+$/i.test(trimmed(value));

/** Текст ошибки формы или null, если сохранять можно. */
export const validateBiometryDraft = (draft, saved) => {
  const baseUrl = trimmed(draft?.baseUrl);
  if (baseUrl && !isHttpUrl(baseUrl)) {
    return 'Адрес сервиса должен начинаться с http:// или https://';
  }

  if (draft?.enabled) {
    if (!baseUrl) {
      return 'Чтобы включить биометрию, укажите адрес сервиса';
    }
    if (!trimmed(draft.token) && !saved?.hasToken) {
      return 'Чтобы включить биометрию, укажите токен доступа';
    }
  }

  return null;
};

export const buildBiometryPayload = (draft) => ({
  enabled: Boolean(draft?.enabled),
  baseUrl: trimmed(draft?.baseUrl) || null,
  token: trimmed(draft?.token) || null,
  model: trimmed(draft?.model) || null
});

/** Есть ли в форме несохранённые изменения. */
export const isBiometryDraftDirty = (draft, saved) => {
  const original = draftFromSettings(saved);
  return (
    Boolean(draft?.enabled) !== original.enabled ||
    trimmed(draft?.baseUrl) !== trimmed(original.baseUrl) ||
    trimmed(draft?.model) !== trimmed(original.model) ||
    Boolean(trimmed(draft?.token))
  );
};

export const tokenPlaceholder = (saved) => {
  if (!saved?.hasToken) {
    return 'bio_…';
  }
  const hint = saved.tokenHint ? `…${saved.tokenHint}` : 'сохранён';
  return `${hint} — оставьте пустым, чтобы не менять`;
};

/** Итог проверки подключения: { ok, title, details[] } или null, если проверки ещё не было. */
export const describeCheckResult = (result) => {
  if (!result) {
    return null;
  }

  if (!result.ok) {
    return {
      ok: false,
      title: 'Подключение не работает',
      details: [result.error || 'Неизвестная ошибка']
    };
  }

  const details = [];
  if (result.tokenName) {
    details.push(`Токен: ${result.tokenName}`);
  }
  if (result.modelSlug) {
    const model = result.modelName ? `${result.modelName} (${result.modelSlug})` : result.modelSlug;
    details.push(`Модель: ${model}`);
  }
  if (Number.isFinite(result.employees)) {
    details.push(`Сотрудников с эталонами: ${result.employees}`);
  }
  if (result.apiVersion === '1.0') {
    details.push(result.notReadyReason || 'Сервис версии 1.0: моделей нет.');
  }

  return { ok: true, title: 'Подключение работает', details };
};
